import { gql } from '@apollo/client';

import { FileUploadFragment } from './FileUpload.graphql';
import { ProductFragment } from './Product.graphql';

export const SredProjectFragment = gql`
  fragment SredProject on SredProject {
    id
    name
    description
    consideredForSred
    selectedCategory
    sredDocumentationStatus
    projectOwnerId
    projectOwner {
      id
      fullName
    }
    workstreamNames
    workstreamNamesSearch
    ticketCount
    supportingDocuments {
      ...FileUpload
    }
    processingState
    product {
      ...Product
    }
    clusterType
    approvalTime
    approvalComment
    aiGuidance
    appliedResearch
    basicResearch
    experimentalDevelopment
    systematicInvestigation
    technologicalAdvancement
    technologicalUncertainty
    supportingWork
    provincialEligibility
    workInCanadaPercentage
    sredEligibleDate
    productName
    projectOwnerName
  }
  ${FileUploadFragment}
  ${ProductFragment}
`;
